import styled from "styled-components";
import { styled as MuiStyled } from "@mui/material/styles";
import { colorTokens, ctaAccentColor, textTokens } from "./globalStyles";

// ---------------------------------------------------------------------------
// Icons used by createDynamicIcon (need local binding)
// ---------------------------------------------------------------------------

import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import VerifiedIcon from "@mui/icons-material/Verified";
import DoneIcon from "@mui/icons-material/Done";
import QuizIcon from "@mui/icons-material/Quiz";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DownloadIcon from "@mui/icons-material/Download";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PlaylistAddCircleIcon from "@mui/icons-material/PlaylistAddCircle";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import SchoolIcon from "@mui/icons-material/School";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import GroupIcon from "@mui/icons-material/Group";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import LaunchIcon from "@mui/icons-material/Launch";
import NotesIcon from "@mui/icons-material/Notes";
import InfoIcon from "@mui/icons-material/Info";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import UndoIcon from "@mui/icons-material/Undo";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import DvrIcon from "@mui/icons-material/Dvr";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import SettingsGearIcon from "@mui/icons-material/Settings";
import AddToPhotosIcon from "@mui/icons-material/AddToPhotos";
import AddBoxIcon from "@mui/icons-material/AddBox";
import GroupsIcon from "@mui/icons-material/Groups";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssignmentIcon from "@mui/icons-material/Assignment";
import CategoryIcon from "@mui/icons-material/Category";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import HomeRoundedIcon from "@mui/icons-material/Home";
import LogoutRoundedIcon from "@mui/icons-material/Logout";
import HistoryIcon from "@mui/icons-material/History";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InventoryIcon from "@mui/icons-material/Inventory2";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import TuneLocalIcon from "@mui/icons-material/Tune";
import BlockIcon from "@mui/icons-material/Block";
import RemoveIcon from "@mui/icons-material/Remove";
import SmartphoneIconLocal from "@mui/icons-material/Smartphone";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import SendIcon from "@mui/icons-material/Send";
import AndroidIconLocal from "@mui/icons-material/Android";
import BackpackIcon from "@mui/icons-material/Backpack";
import EventIconLocal from "@mui/icons-material/Event";
import StorefrontIcon from "@mui/icons-material/Storefront";
export {
  AddIcon,
  CalendarMonthIcon,
  ChatBubbleOutlineIcon,
  CloseIcon,
  DeleteForeverIcon,
  DoneIcon,
  DownloadIcon,
  EditIcon,
  GroupsIcon,
  HomeRoundedIcon,
  InfoIcon,
  PersonAddIcon,
  PersonIcon,
  RefreshIcon,
  SaveIcon,
  SchoolIcon,
  SettingsGearIcon,
  VisibilityIcon,
};

// ---------------------------------------------------------------------------
// Raw icon re-exports (not used locally, pass-through only)
// ---------------------------------------------------------------------------

export { default as AddAlertIcon } from "@mui/icons-material/AddAlert";
export { default as AddCircleIcon } from "@mui/icons-material/AddCircle";
export { default as AddCircleOutlineIcon } from "@mui/icons-material/AddCircleOutline";
export { default as AddOutlinedIcon } from "@mui/icons-material/AddOutlined";
export { default as ArrowDownwardIcon } from "@mui/icons-material/ArrowDownward";
export { default as AttachMoneyIcon } from "@mui/icons-material/AttachMoney";
export { default as ArrowUpwardIcon } from "@mui/icons-material/ArrowUpward";
export { default as BarChartIcon } from "@mui/icons-material/BarChart";
export { default as CalendarTodayIcon } from "@mui/icons-material/CalendarToday";
export { default as CalendarViewDayIcon } from "@mui/icons-material/CalendarViewDay";
export { default as CalendarViewMonthIcon } from "@mui/icons-material/CalendarViewMonth";
export { default as CalendarViewWeekIcon } from "@mui/icons-material/CalendarViewWeek";
export { default as CancelIcon } from "@mui/icons-material/Cancel";
export { default as CasinoIcon } from "@mui/icons-material/Casino";
export { default as CheckCircleIcon } from "@mui/icons-material/CheckCircle";
export { default as CheckIcon } from "@mui/icons-material/Check";
export { default as CheckRoundedIcon } from "@mui/icons-material/CheckRounded";
export { default as ChevronLeftIcon } from "@mui/icons-material/ChevronLeft";
export { default as ChevronRightIcon } from "@mui/icons-material/ChevronRight";
export { default as CloseRoundedIcon } from "@mui/icons-material/CloseRounded";
export { default as CloudUploadIcon } from "@mui/icons-material/CloudUpload";
export { default as ColorLensIcon } from "@mui/icons-material/ColorLens";
export { default as ContentCopyIcon } from "@mui/icons-material/ContentCopy";
export { default as ControlPointDuplicateOutlinedIcon } from "@mui/icons-material/ControlPointDuplicateOutlined";
export { default as DateRangeIcon } from "@mui/icons-material/DateRange";
export { default as DeleteIcon } from "@mui/icons-material/Delete";
export { default as DeleteOutlineIcon } from "@mui/icons-material/DeleteOutline";
export { default as DragIndicatorIcon } from "@mui/icons-material/DragIndicator";
export { default as DriveFileRenameOutlineIcon } from "@mui/icons-material/DriveFileRenameOutline";
export { default as EmailIcon } from "@mui/icons-material/Email";
export { default as FacebookIcon } from "@mui/icons-material/Facebook";
export { default as GoogleIcon } from "@mui/icons-material/Google";
export { default as EventIcon } from "@mui/icons-material/Event";
export { default as InstagramIcon } from "@mui/icons-material/Instagram";
export { default as LanguageIcon } from "@mui/icons-material/Language";
export { default as LinkedInIcon } from "@mui/icons-material/LinkedIn";
export { default as PhoneIcon } from "@mui/icons-material/Phone";
export { default as FilterListIcon } from "@mui/icons-material/FilterList";
export { default as FlagOutlinedIcon } from "@mui/icons-material/FlagOutlined";
export { default as FirstPageIcon } from "@mui/icons-material/FirstPage";
export { default as FormatBoldIcon } from "@mui/icons-material/FormatBold";
export { default as FormatItalicIcon } from "@mui/icons-material/FormatItalic";
export { default as ImageIcon } from "@mui/icons-material/Image";
export { default as InventoryMenuIcon } from "@mui/icons-material/Inventory";
export { default as KeyboardArrowDownIcon } from "@mui/icons-material/KeyboardArrowDown";
export { default as LastPageIcon } from "@mui/icons-material/LastPage";
export { default as LinkIcon } from "@mui/icons-material/Link";
export { default as MailIcon } from "@mui/icons-material/Mail";
export { default as ManageAccountsIcon } from "@mui/icons-material/ManageAccounts";
export { default as MilitaryTechIcon } from "@mui/icons-material/MilitaryTech";
export { default as MoreHorizIcon } from "@mui/icons-material/MoreHoriz";
export { default as NotificationsActiveIcon } from "@mui/icons-material/NotificationsActive";
export { default as NotificationsNoneIcon } from "@mui/icons-material/NotificationsNone";
export { default as NumbersIcon } from "@mui/icons-material/Numbers";
export { default as OpenInNewIcon } from "@mui/icons-material/OpenInNew";
export { default as PendingIcon } from "@mui/icons-material/Pending";
export { default as PeopleAltIcon } from "@mui/icons-material/PeopleAlt";
export { default as PeopleIcon } from "@mui/icons-material/People";
export { default as PersonRemoveIcon } from "@mui/icons-material/PersonRemove";
export { default as PersonSearchIcon } from "@mui/icons-material/PersonSearch";
export { default as PlaylistAddIcon } from "@mui/icons-material/PlaylistAdd";
export { default as QrCodeIcon } from "@mui/icons-material/QrCode";
export { default as RemoveCircleOutlineIcon } from "@mui/icons-material/RemoveCircleOutline";
export { default as ReportIcon } from "@mui/icons-material/Report";
export { default as RestartAltIcon } from "@mui/icons-material/RestartAlt";
export { default as SchoolOutlinedIcon } from "@mui/icons-material/SchoolOutlined";
export { default as SearchRoundedIcon } from "@mui/icons-material/SearchRounded";
export { default as SmartButtonOutlinedIcon } from "@mui/icons-material/SmartButtonOutlined";
export { default as SmartphoneIcon } from "@mui/icons-material/Smartphone";
export { default as SortByAlphaIcon } from "@mui/icons-material/SortByAlpha";
export { default as SortIcon } from "@mui/icons-material/Sort";
export { default as StarIcon } from "@mui/icons-material/Star";
export { default as TodayIcon } from "@mui/icons-material/Today";
export { default as ToggleOffIcon } from "@mui/icons-material/ToggleOff";
export { default as ToggleOnIcon } from "@mui/icons-material/ToggleOn";
export { default as TrophyIcon } from "@mui/icons-material/EmojiEvents";
export { default as TuneIcon } from "@mui/icons-material/Tune";
export { default as UnfoldMoreIcon } from "@mui/icons-material/UnfoldMore";
export { default as UndoIcon } from "@mui/icons-material/Undo";
export { default as UnsubscribeIcon } from "@mui/icons-material/Unsubscribe";
export { default as VisibilityOffIcon } from "@mui/icons-material/VisibilityOff";
export { default as WifiIcon } from "@mui/icons-material/Wifi";
export { default as WifiOffIcon } from "@mui/icons-material/WifiOff";
export { default as WarningAmberRoundedIcon } from "@mui/icons-material/WarningAmberRounded";
export { default as WarningIcon } from "@mui/icons-material/Warning";
export { default as WhatsAppIcon } from "@mui/icons-material/WhatsApp";
export { default as YouTubeIcon } from "@mui/icons-material/YouTube";

// ---------------------------------------------------------------------------
// Styled icons (S-prefix, with accent color + hover)
// ---------------------------------------------------------------------------

const createDynamicIcon = (Icon: React.ComponentType, defaultColor: string = ctaAccentColor) =>
  MuiStyled(Icon, {
    shouldForwardProp: (prop) => prop !== "iconColor",
  })<{ iconColor?: string }>(({ theme, iconColor }) => ({
    color: iconColor || defaultColor,
    fontFamily: textTokens.fontFamily,
    cursor: "pointer",
    "&:hover": {
      color: iconColor ? textTokens.color.secondary : "inherit",
    },
    [theme.breakpoints.down("sm")]: {
      transform: "scale(0.8, 0.8)",
    },
  }));

export const SClose = createDynamicIcon(CloseIcon);
export const SEdit = createDynamicIcon(EditIcon);
export const SCreate = createDynamicIcon(AddIcon);
export const SValidate = createDynamicIcon(VerifiedIcon);
export const SDone = createDynamicIcon(DoneIcon);
export const SQuiz = createDynamicIcon(QuizIcon);
export const SQuizz = createDynamicIcon(AssignmentLateIcon);
export const SRefresh = createDynamicIcon(RefreshIcon);
export const SAddPhoto = createDynamicIcon(AddAPhotoIcon);
export const SNoPhoto = createDynamicIcon(NoPhotographyIcon);
export const SDownload = createDynamicIcon(DownloadIcon);
export const SCloudUpload = createDynamicIcon(CloudUploadIcon);
export const SAddDocument = createDynamicIcon(PlaylistAddCircleIcon);
export const SAddCriteria = createDynamicIcon(AddToPhotosIcon);
export const SAddModule = createDynamicIcon(AddBoxIcon);
export const SView = createDynamicIcon(VisibilityIcon);
export const SCreateFolder = createDynamicIcon(CreateNewFolderIcon);
export const SAnalytics = createDynamicIcon(AnalyticsIcon);
export const SMissing = createDynamicIcon(CloseIcon);
export const SMissingFile = createDynamicIcon(QuestionMarkIcon);
export const SSchool = createDynamicIcon(SchoolIcon);
export const SArrow = createDynamicIcon(SubdirectoryArrowRightIcon);
export const SUndo = createDynamicIcon(UndoIcon);
export const SRocket = createDynamicIcon(RocketLaunchIcon);
export const SProduct = createDynamicIcon(ShoppingCartIcon);
export const SHourglass = createDynamicIcon(HourglassEmptyIcon);
export const SPlay = createDynamicIcon(PlayArrowIcon);
export const SStop = createDynamicIcon(StopIcon);
export const SInvoice = createDynamicIcon(AttachMoneyIcon);
export const SSettings = createDynamicIcon(DisplaySettingsIcon);
/** Cogwheel (paramètres généraux), distinct from SSettings (display / sliders). */
export const SGear = createDynamicIcon(SettingsGearIcon);
export const STemplates = createDynamicIcon(DvrIcon);
export const SCreditCard = createDynamicIcon(CreditCardIcon);
export const SSendMail = createDynamicIcon(ForwardToInboxIcon);
export const SStats = createDynamicIcon(QueryStatsIcon);
export const SUsers = createDynamicIcon(GroupIcon);
export const SGroups = createDynamicIcon(GroupsIcon);
export const SDelete = createDynamicIcon(DeleteForeverIcon, colorTokens.status.danger);
export const SSave = createDynamicIcon(SaveIcon);
export const SFile = createDynamicIcon(FilePresentIcon);
export const SDate = createDynamicIcon(AccessTimeIcon);
export const SInfo = createDynamicIcon(InfoIcon);
export const SUserAdd = createDynamicIcon(PersonAddIcon);
export const SRedirect = createDynamicIcon(LaunchIcon);
export const SNotes = createDynamicIcon(NotesIcon);
export const SGenerate = createDynamicIcon(FileOpenIcon);
export const SOpenProfile = createDynamicIcon(AccountCircleIcon);
export const SHome = createDynamicIcon(HomeRoundedIcon);
export const SLogout = createDynamicIcon(LogoutRoundedIcon);
export const SHistory = createDynamicIcon(HistoryIcon);
export const SArrowBack = createDynamicIcon(ArrowBackIcon);
export const SInventory = createDynamicIcon(InventoryIcon);
export const SComment = createDynamicIcon(ChatBubbleOutlineIcon);
export const SExpandMore = createDynamicIcon(ExpandMoreIcon);
export const SExpandLess = createDynamicIcon(ExpandLessIcon);
export const SSwapHoriz = createDynamicIcon(SwapHorizIcon);
export const SBusiness = createDynamicIcon(BusinessIcon);
export const SPerson = createDynamicIcon(PersonIcon);
export const SCalendarMonth = createDynamicIcon(CalendarMonthIcon);
export const SVerifiedUser = createDynamicIcon(VerifiedUserIcon);
export const SWallet = createDynamicIcon(AccountBalanceWalletIcon);
export const SAssignment = createDynamicIcon(AssignmentIcon);
export const SCategory = createDynamicIcon(CategoryIcon);
export const SMailOutline = createDynamicIcon(MailOutlineIcon);
export const STune = createDynamicIcon(TuneLocalIcon);
export const SBlock = createDynamicIcon(BlockIcon, colorTokens.status.danger);
export const SMinus = createDynamicIcon(RemoveIcon);
export const SSmartphone = createDynamicIcon(SmartphoneIconLocal);
export const SSms = createDynamicIcon(SmsOutlinedIcon);
export const SSend = createDynamicIcon(SendIcon);
export const SAndroid = createDynamicIcon(AndroidIconLocal);
export const SRental = createDynamicIcon(BackpackIcon);
export const SEvent = createDynamicIcon(EventIconLocal);
export const SCentre = createDynamicIcon(StorefrontIcon);

// ---------------------------------------------------------------------------
// Styled components
// ---------------------------------------------------------------------------

export const SBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: "calc(100vh - 64px)";
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const SPhoto = styled.img`
  width: 100%;
  border-radius: 50%;
`;
